import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import camelCase from 'lodash/camelCase';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';
import InlineSelect from '../InlineSelect';

const amountOptions = t => [
  { value: 3, display: t('much more than a lot') },
  { value: 2.45, display: t('more than a lot') },
  { value: 2.1, display: t('a lot') },
  { value: 1.8, display: t('much more than average') },
  { value: 1.45, display: t('more than average') },
  { value: 1.15, display: t('just above average') },
  { value: 1, display: t('average') },
  { value: 0.85, display: t('almost average') },
  { value: 0.65, display: t('less than average') },
  { value: 0.45, display: t('much less than average') },
  { value: 0.25, display: t('very little') },
  { value: 0, display: t('none') },
];

const subcategories = t => [
  {
    title: t('Meat'),
    apiKey: 'input_takeaction_low_carbon_diet_meatfootprint',
    resultKey: 'result_takeaction_low_carbon_diet_meatcal',
  }, {
    title: t('Dairy'),
    apiKey: 'input_takeaction_low_carbon_diet_dairyfootprint',
    resultKey: 'result_takeaction_low_carbon_diet_dairycal',
  }, {
    title: t('Fruit/veg'),
    apiKey: 'input_takeaction_low_carbon_diet_fvfootprint',
    resultKey: 'result_takeaction_low_carbon_diet_fvcal',
  }, {
    title: t('Cereals'),
    apiKey: 'input_takeaction_low_carbon_diet_cerealsfootprint',
    resultKey: 'result_takeaction_low_carbon_diet_cerealscal',
  }, {
    title: t('Other'),
    apiKey: 'input_takeaction_low_carbon_diet_otherfootprint',
    resultKey: 'result_takeaction_low_carbon_diet_othercal',
  },
];

const EatLowCarbonDiet = ({
  t,
  _t,
  widgetSource,
  ...results
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('Use the selectors below to choose your new diet. How much of the following will each person eat daily (calories per day)')}
      </p>
      <ul>
        {subcategories(t).map(({ apiKey, resultKey, title }) => (
          <li key={apiKey}>
            {t('{{prefix}}:', { prefix: title })}
            <InlineSelect
              options={amountOptions(t)}
              apiKey={apiKey}
            />
            {t('{{result}} calories/day', { result: results[camelCase(resultKey)] })}
          </li>
        ))}
      </ul>
      <p>
        <b>{t('Total:')}&nbsp;</b>
        {t('{{result}} calories/day', { result: results.resultTakeactionLowCarbonDietTotalcal })}
      </p>
    </div>
    {widgetSource !== 'ontario' && <div className="action-details__facts">
      {t('A third of all food emissions in the United States come from red meat and dairy products, while chicken and vegetables have up to ten times smaller footprints per serving, so small diet switches can make a BIG difference.')}
    </div>}
    {widgetSource === 'ontario' && <div className="action-details__facts">
      {t('A third of all food emissions come from red meat and dairy products, while chicken and vegetables have up to ten times smaller footprints per serving, so small diet switches can make a BIG difference.')}
    </div>}
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        {widgetSource !== 'ontario' && <li>
          {t('Food prices are based on average U.S. prices for each category of food items (meat, dairy, fruits & vegetables, cereals and other). The actual carbon footprint and price of food you purchase may vary substantially from these values.')}
        </li>}
        {widgetSource === 'ontario' && <li>
          {t('Food prices are based on average prices for each category of food items (meat, dairy, fruits & vegetables, cereals and other). The actual carbon footprint and price of food you purchase may vary substantially from these values.')}
        </li>}
      </ul>
    </div>
  </div>
);

EatLowCarbonDiet.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  _t: PropTypes.func.isRequired,
  // connected props
  widgetSource: PropTypes.string.isRequired,
  resultTakeactionLowCarbonDietMeatcal: PropTypes.string.isRequired,
  resultTakeactionLowCarbonDietDairycal: PropTypes.string.isRequired,
  resultTakeactionLowCarbonDietFvcal: PropTypes.string.isRequired,
  resultTakeactionLowCarbonDietCerealscal: PropTypes.string.isRequired,
  resultTakeactionLowCarbonDietOthercal: PropTypes.string.isRequired,
  resultTakeactionLowCarbonDietTotalcal: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  resultTakeactionLowCarbonDietMeatcal: s.results('resultTakeactionLowCarbonDietMeatcal')(state, ownProps),
  resultTakeactionLowCarbonDietDairycal: s.results('resultTakeactionLowCarbonDietDairycal')(state, ownProps),
  resultTakeactionLowCarbonDietFvcal: s.results('resultTakeactionLowCarbonDietFvcal')(state, ownProps),
  resultTakeactionLowCarbonDietCerealscal: s.results('resultTakeactionLowCarbonDietCerealscal')(state, ownProps),
  resultTakeactionLowCarbonDietOthercal: s.results('resultTakeactionLowCarbonDietOthercal')(state, ownProps),
  resultTakeactionLowCarbonDietTotalcal: s.results('resultTakeactionLowCarbonDietTotalcal')(state, ownProps),
  widgetSource: s.widgetSource(state),
});
const mapDispatchToProps = (_dispatch, _ownProps) => ({});

export default wrap(
  withT('lowCarbonDiet'),
  connect(mapStateToProps, mapDispatchToProps)(EatLowCarbonDiet),
);
